import React from 'react';

import { Row } from 'react-data-grid'

class RowRenderer extends React.Component {
  getRowClass() {
    const { row, threshold } = this.props
    const { removed, newentry, published, title_length } = row

    const titleClass = ( title_length > threshold ) ? "dangerLength " : ""

    if ( !published ) {
      return `${titleClass}entry-unpublished`
    } else if (removed) {
      return `${titleClass}entry-removed`
    } else if (newentry) {
      return `${titleClass}entry-newentry`
    } else {
      return titleClass
    }
  };

  getRowTitle() {
    const { row, threshold } = this.props
    const { removed, newentry, published, title_length } = row

    const titleClass = ( title_length > threshold ) ? `Item full title is longer than the allowed threshold of ${threshold} characters.\n` : ""

    if ( !published ) {
      return `${titleClass}Unpublished Row (manually)`
    } else if (removed) {
      return `${titleClass}Removed Row (unavailable item)`
    } else if (newentry) {
      return `${titleClass}New Row (new item)`
    } else {
      return titleClass
    }
  }

  render() {
    // here we are just changing the style
    // but we could replace this with anything we liked, cards, images, etc
    // usually though it will just be a matter of wrapping a div, and then calling back through to the grid
    return (<div className={this.getRowClass()} title={this.getRowTitle()}><Row ref={ node => this.row = node } {...this.props}/></div>);
  }
}

export default RowRenderer;



// WEBPACK FOOTER //
// ./src/js/components/RowRenderer.js